// Start pagination helpers

const MIN_PAGE_AMOUNT = 1;

const getRange = (start, end) => {
  return Array(end - start + 1).fill().map((_, i) => i + start);
}

const getPaginationArray = (current, total, delta) => {
  const range = {
    start: Math.round(current - delta / 2),
    end: Math.round(current + delta / 2)
  };

  if (range.start - 1 === 1 || range.end + 1 === total) {
    range.start += 1;
    range.end += 1;
  }

  let pages = current > delta ? getRange(
    Math.min(range.start, total - delta),
    Math.min(range.end, total)
  ) : getRange(1, Math.min(total, delta + 1));

  const withDots = (value, pair) => pages.total + 1 !== total ? pair : [value];

  if (pages[0] !== 1) {
    pages = withDots(1, [1, '...']).concat(pages);
  }

  if (pages[pages.length - 1] < total) {
    pages = pages.concat(withDots(total, ['...', total]));
  }

  return pages;
}

// End pagination helpers

// Start meta helpers

const getNewMetaDescriptionContent = (oldContent, totalPages, currentPage) => {
  const hasPagination = !!totalPages && !!currentPage && (currentPage > MIN_PAGE_AMOUNT);
  const pagesStateText = hasPagination ? `- Сторінка ${currentPage} з ${totalPages}` : '';

  if (oldContent && oldContent.trim().length) {
    return `${oldContent} ${pagesStateText}`;
  }

  const dataAttrName = 'data-page-name';
  const pageDataAttrElement = document.querySelector('[data-page-name]');
  const pageDataAttrValue = pageDataAttrElement?.getAttribute(dataAttrName) || '';
  const authorPageElement = document.querySelector('.author-template');

  const descriptionTagContent = `Актуальні статті по темі ${pageDataAttrValue}. Всі найновіші і найкорисніші матеріали з категорії "${pageDataAttrValue}" на сайті ProIT - медіа для профі в IT.`;

  const descriptionAuthorContent = `${pageDataAttrValue}. Читайте усі матеріали автора ${pageDataAttrValue} на сайті ProIT - медіа для профі в IT.`;


  return `${authorPageElement ? descriptionAuthorContent : descriptionTagContent} ${pagesStateText}`;
}

const setMetaDescriptionContent = (content) => {
  if (!content) {
    return;
  }
  const headTag = document.querySelector('head');
  const newMetaDescription = document.createElement('meta');
  newMetaDescription.setAttribute('name', 'description');
  newMetaDescription.setAttribute('content', content);
  headTag.appendChild(newMetaDescription);
}

const handlingPageMetaDescription = (totalPages = null, currentPage = null, paginationContainer = null) => {
  const authorBioElement = document.querySelector('[data-author-bio]');
  const authorBioData = authorBioElement?.getAttribute('data-author-bio');
  const metaDescription = document.querySelector('meta[name="description"]');

  if (authorBioData?.length) {
    metaDescription ? metaDescription.setAttribute('content', getNewMetaDescriptionContent(authorBioData, totalPages, currentPage)) :
      setMetaDescriptionContent(getNewMetaDescriptionContent(authorBioData, totalPages, currentPage));
    return;
  }

  if (metaDescription) {
    const metaDescriptionContent = metaDescription.getAttribute('content');
    metaDescription.setAttribute('content', getNewMetaDescriptionContent(metaDescriptionContent, totalPages, currentPage));
  } else {
    const metaDescriptionContent = paginationContainer ? paginationContainer?.getAttribute('data-meta-description') || '' : '';
    const newMetaDescriptionContent = getNewMetaDescriptionContent(metaDescriptionContent, totalPages, currentPage);
    setMetaDescriptionContent(newMetaDescriptionContent);
  }
}

// End meta helpers

document.addEventListener('DOMContentLoaded', () => {
  const paginationContainer = document.querySelector('#custom-pagination-container');

  if (paginationContainer) {

    // Start pagination

    const totalPages = parseInt(paginationContainer.getAttribute('data-total-pages'));
    const currentPage = parseInt(paginationContainer.getAttribute('data-current-page'));
    const pageUrl = paginationContainer.getAttribute('data-page-url');
    const screenWidth = document.querySelector('body')?.offsetWidth || 0;
    const MIN_SCREEN_SIZE = 600;
    const DELTA = screenWidth > MIN_SCREEN_SIZE ? 6 : 2;
    const DOTS_STEP = 1;

    paginationContainer.innerHTML = '';

    const createPaginationButton = (pageNumber, textContent) => {
      const listItem = document.createElement('li');
      const paginationLink = document.createElement('a');
      paginationLink.classList.add('custom-pagination__link');
      paginationLink.textContent = textContent;
      paginationLink.href = pageNumber !== 1 ? `${pageUrl}page/${pageNumber}/` : pageUrl;
      listItem.appendChild(paginationLink);
      paginationContainer.appendChild(listItem);
    }

    const rangeWithDots = getPaginationArray(currentPage, totalPages, DELTA);

    rangeWithDots.forEach((item, index) => {
      if (item === currentPage) {
        const listItem = document.createElement('li');
        listItem.classList.add('custom-pagination__link', 'active')
        listItem.textContent = item;
        paginationContainer.appendChild(listItem);
        return
      }

      if (item === '...') {
        const targetPageNumber = index > Math.floor(rangeWithDots.length / 2) ? rangeWithDots[index - 1] + DOTS_STEP : rangeWithDots[index + 1] - DOTS_STEP;
        createPaginationButton(targetPageNumber, item);
        return
      }
      createPaginationButton(item, item);
    })

    // End pagination

    // Start meta description

    handlingPageMetaDescription(totalPages, currentPage, paginationContainer);
    return;

  }
  handlingPageMetaDescription();

  // End meta description
});